import { useState, useEffect } from "react";
import InputData from "../components/InputData";
import DataTable from "react-data-table-component";
import ButtonIconH from "../components/ButtonIconH";
import InputIconSearchPanel from "../components/InputIconSearchPanel";
import InputIconSearchPanelMultiSelection from "../components/InputIconSearchPanelMultiSelection";
import DropdownFilter from "../components/DropdownFilter";
import Tag from "../components/Tag";
import {
  focusElement,
  inputOnEnter,
  deliveryNoteElements,
  userData,
  productFamilies,
  selectedOptic,
  LIMIT,
  formatValueUnit,
} from "../js/utils";
import { deliveryNoteColumns } from "../js/tableColumns";
import { post } from "../js/post";
import "../css/Store.css";
import "../css/DeliveryNote.css";
import moment from "moment";
import { useSuppliers } from "../hooks/useSuppliers";

export default function DeliveryNote(props) {
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceStartDate, setInvoiceStartDate] = useState("");
  const [invoiceEndDate, setInvoiceEndDate] = useState("");
  const [purchaseStartDate, setPurchaseStartDate] = useState("");
  const [purchaseEndDate, setPurchaseEndDate] = useState("");
  const [creationStartDate, setCreationStartDate] = useState("");
  const [creationEndDate, setCreationEndDate] = useState("");
  const [supplierName, setSupplierName] = useState("");
  const [deliveryNoteCode, setDeliveryNoteCode] = useState("");
  const [selectedFamilies, setSelectedFamilies] = useState([]);
  const [deliveryNoteList, setDeliveryNoteList] =
    useState(deliveryNoteElements);
  const [supplierList, refreshSuppliers] = useSuppliers("", supplierName, "");
  const [limit, setLimit] = useState(LIMIT);
  const [total, setTotal] = useState(0);

  const conditionalRowStyles = [
    {
      when: (row) => row.borrador,
      style: {
        backgroundColor: "#ffdfbbff",
      },
    },
  ];

  function resetFilters() {
    focusElement(3);
    setInvoiceNumber("");
    setInvoiceStartDate("");
    setInvoiceEndDate("");
    setPurchaseStartDate("");
    setPurchaseEndDate("");
    setSupplierName("");
    setDeliveryNoteCode("");
    setCreationStartDate("");
    setCreationEndDate("");
    setSelectedFamilies([]);
  }

  async function getDeliveryNoteList(from, total, add) {
    const response = await post("support-extra/albaran/ListarAlbaranes.php", {
      token: userData.token,
      numAlbaranFact: invoiceNumber,
      fechaAlbaranDesde: invoiceStartDate,
      fechaAlbaranHasta: invoiceEndDate,
      fechaCompraDesde: purchaseStartDate,
      fechaCompraHasta: purchaseEndDate,
      fechaCreacionDesde: creationStartDate,
      fechaCreacionHasta: creationEndDate,
      familia: refineSelectedFamilies(),
      nombreProveedor: supplierName,
      codigo: deliveryNoteCode,
      start: from,
      total,
      estadoBorrafor: 0,
    });

    // console.log(
      // "LISTANDO ALBARANES: ",
      // {
        // token: userData.token,
        // numAlbaranFact: invoiceNumber,
        // fechaAlbaranDesde: invoiceStartDate,
        // fechaAlbaranHasta: invoiceEndDate,
        // fechaCompraDesde: purchaseStartDate,
        // fechaCompraHasta: purchaseEndDate,
        // fechaCreacionDesde: creationStartDate,
        // fechaCreacionHasta: creationEndDate,
        // familia: refineSelectedFamilies(),
        // nombreProveedor: supplierName,
        // codigo: deliveryNoteCode,
        // start: from,
        // total,
        // estadoBorrafor: 0,
      // },
      // response,
    // );

    let responseAux = response.albaranes;
    setTotal(response.totalAlbaranes);
    if (add) {
      setDeliveryNoteList((prev) => {
        return [...prev, ...responseAux];
      });
    } else setDeliveryNoteList(responseAux);
  }

  const refineSelectedFamilies = () => {
    return selectedFamilies.map((f) => productFamilies.indexOf(f));
  };

  const createDeliveryNote = async () => {
    const response = await post("support-extra/albaran/CrearAlbaran.php", {
      token: userData.token,
      idUsuario: userData.id,
      idOptica: selectedOptic.id,
    });
    if (response.idAlbaran) {
      props.openDeliveryNotePanel(response.idAlbaran, true);
    }
  };

  useEffect(() => {
    getDeliveryNoteList(0, limit, false);
  }, [
    invoiceStartDate,
    invoiceEndDate,
    purchaseStartDate,
    purchaseEndDate,
    creationStartDate,
    creationEndDate,
    selectedFamilies,
    props.closeDeliveryNotePanel,
  ]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getDeliveryNoteList(0, limit, false);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [invoiceNumber, deliveryNoteCode, supplierName]);

  useEffect(() => {
    if (props.show === true) {
      focusElement(1);
      refreshSuppliers("", supplierName, "");
    }
  }, [props]);

  useEffect(() => {
    getDeliveryNoteList(0, limit, false);
  }, [limit]);

  if (!props.show) {
    return <></>;
  }

  return (
    <div className="patient-data">
      <div className="patient-data-header">
        <span className="header-text">Albaranes</span>
        <div className="patient-header-buttons"></div>
      </div>
      <div className="patient-data-content store-data-content delivery-note-content">
        <div className="action-bar">
          <div className="action-bar-resume">
            <span>Almacén</span>
            <span>|</span>
            <span className="signed-text">Albaranes</span>
          </div>
        </div>
        <div className="patient-info store-info">
          <div
            className="opt-table-title"
            style={{ justifyContent: "space-between" }}
          >
            <span>Búsqueda de albarán</span>
            <button className="cell-label" onClick={resetFilters} tabIndex={-1}>
              Limpiar filtros
            </button>
          </div>
          <div
            className="opt-table-content grid-9"
            id="delivery-note-filters-grid"
          >
            <div className="cell cell-start-content data-field">
              <span className="label">Nº albarán</span>
            </div>
            <div className="cell">
              <InputData
                tabIndex={1}
                type="type-alphanum-ext"
                size={0}
                input={invoiceNumber}
                onChange={(e) => {
                  setInvoiceNumber(e);
                }}
              ></InputData>
            </div>
            <div className="cell"></div>
            <div className="cell cell-start-content data-field">
              <span className="label">Fecha albarán desde</span>
            </div>
            <div className="cell"></div>
            <div className="cell">
              <input
                type="date"
                max="9999-12-31"
                tabIndex={5}
                className="input-field input-cell w-100"
                value={invoiceStartDate}
                onChange={(e) => {
                  const value = e.target.value;
                  setInvoiceStartDate(
                    value ? moment(value).format("YYYY-MM-DD") : "",
                  );
                }}
                onKeyUp={(e) => inputOnEnter(e)}
              ></input>
            </div>
            <div className="cell"></div>
            <div className="cell cell-start-content data-field">
              <span className="label">Fecha compra desde</span>
            </div>
            <div className="cell">
              <input
                type="date"
                max="9999-12-31"
                tabIndex={9}
                className="input-field input-cell w-100"
                value={purchaseStartDate}
                onChange={(e) => {
                  const value = e.target.value;
                  setPurchaseStartDate(
                    value ? moment(value).format("YYYY-MM-DD") : "",
                  );
                }}
                onKeyUp={(e) => inputOnEnter(e)}
              ></input>
            </div>
            <div className="cell cell-start-content data-field">
              <span className="label">Fam + Cod/EAN/UPC</span>
            </div>
            <div className="cell">
              <InputData
                tabIndex={2}
                type="type-alphanum-ext"
                size={0}
                input={deliveryNoteCode}
                onChange={(e) => {
                  setDeliveryNoteCode(e);
                }}
              ></InputData>
            </div>
            <div className="cell"></div>
            <div className="cell cell-start-content data-field">
              <span className="label">Fecha albarán hasta</span>
            </div>
            <div className="cell"></div>
            <div className="cell">
              <input
                type="date"
                max="9999-12-31"
                tabIndex={6}
                className="input-field input-cell w-100"
                value={invoiceEndDate}
                onChange={(e) => {
                  const value = e.target.value;
                  setInvoiceEndDate(
                    value ? moment(value).format("YYYY-MM-DD") : "",
                  );
                }}
                onKeyUp={(e) => inputOnEnter(e)}
              ></input>
            </div>
            <div className="cell"></div>
            <div className="cell cell-start-content data-field">
              <span className="label">Fecha compra hasta</span>
            </div>
            <div className="cell">
              <input
                type="date"
                max="9999-12-31"
                tabIndex={10}
                className="input-field input-cell w-100"
                value={purchaseEndDate}
                onChange={(e) => {
                  const value = e.target.value;
                  setPurchaseEndDate(
                    value ? moment(value).format("YYYY-MM-DD") : "",
                  );
                }}
                onKeyUp={(e) => inputOnEnter(e)}
              ></input>
            </div>
            <div className="cell cell-start-content data-field">
              <span className="label">Proveedor</span>
            </div>
            <div className="cell">
              <InputIconSearchPanel
                size={0}
                tabIndex={3}
                type="type-alphanum-ext"
                options={supplierList}
                input={supplierName}
                onChange={(e) => {
                  setSupplierName(e);
                }}
                onClear={() => {
                  setSupplierName("");
                }}
                onSelect={(e) => {
                  setSupplierName(e);
                }}
              ></InputIconSearchPanel>
            </div>
            <div className="cell"></div>
            <div className="cell cell-start-content data-field">
              <span className="label">Fecha creación desde</span>
            </div>
            <div className="cell"></div>
            <div className="cell">
              <input
                type="datetime-local"
                max="9999-12-31"
                tabIndex={7}
                className="input-field input-cell w-100"
                value={creationStartDate}
                onChange={(e) => {
                  const value = e.target.value;
                  setCreationStartDate(
                    value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "",
                  );
                }}
                onKeyUp={(e) => inputOnEnter(e)}
              ></input>
            </div>
            <div className="cell combined-cells-3"></div>
            <div className="cell cell-start-content data-field">
              <span className="label">Familias de producto</span>
            </div>
            <div className="cell">
              <InputIconSearchPanelMultiSelection
                size={0}
                tabIndex={4}
                type={"type-alphanum-ext"}
                options={productFamilies}
                selectedOptions={selectedFamilies}
                onChange={(e) => {
                  setSelectedFamilies(e);
                }}
              ></InputIconSearchPanelMultiSelection>
            </div>
            <div className="cell"></div>
            <div className="cell cell-start-content data-field">
              <span className="label">Fecha creación hasta</span>
            </div>
            <div className="cell"></div>
            <div className="cell">
              <input
                type="datetime-local"
                max="9999-12-31"
                tabIndex={8}
                className="input-field input-cell w-100"
                value={creationEndDate}
                onChange={(e) => {
                  const value = e.target.value;
                  setCreationEndDate(
                    value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "",
                  );
                }}
                onKeyUp={(e) => inputOnEnter(e)}
              ></input>
            </div>
            <div className="cell combined-cells-3"></div>
            <div
              className="cell combined-cells-9"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              {selectedFamilies.length > 0 && (
                <span style={{ fontWeight: "500", fontSize: 13 }}>
                  Familias seleccionadas: {selectedFamilies.length}
                </span>
              )}
              <div className="tag-content">
                {selectedFamilies.map((e, i) => {
                  return (
                    <Tag
                      text={e}
                      key={i}
                      tagId={i}
                      onClick={(e) => {
                        setSelectedFamilies((prev) =>
                          prev.filter((brand) => brand !== e),
                        );
                      }}
                    ></Tag>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="patient-info store-info">
          <div className="opt-table-title opt-table-title-button">
            <div>
              Listado de albaranes ({formatValueUnit(deliveryNoteList.length)}{" "}
              de{" "}
              <span style={{ color: "#41b3ff" }}>{formatValueUnit(total)}</span>
              )
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 30 }}>
              <DropdownFilter
                disabled={false}
                optionList={[
                  { id: "00", text: "25", active: limit === 25 },
                  { id: "01", text: "50", active: limit === 50 },
                  { id: "02", text: "100", active: limit === 100 },
                ]}
                op={"Mostrando " + limit}
                selectedOptions={[]}
                onChange={(e) => {
                  setLimit(parseInt(e.text));
                }}
              ></DropdownFilter>
              <ButtonIconH
                text="Nuevo albarán"
                highlight={true}
                small={true}
                onClick={async () => {
                  await createDeliveryNote();
                }}
              ></ButtonIconH>
            </div>
          </div>
          <div
            className="store-products-table delivery-note-table"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 20,
            }}
          >
            <DataTable
              columns={deliveryNoteColumns}
              data={deliveryNoteList}
              className="custom-datatable"
              noDataComponent="No hay albaranes disponibles."
              conditionalRowStyles={conditionalRowStyles}
              onRowClicked={(row, event) => {
                props.openDeliveryNotePanel(row.id, true);
              }}
            />
            <ButtonIconH
              text="Ver más"
              small={true}
              onClick={() => {
                getDeliveryNoteList(deliveryNoteList.length, limit, true);
              }}
            ></ButtonIconH>
          </div>
        </div>
      </div>
    </div>
  );
}
